import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SubscriptionForRegister } from '../_models/SubscriptionForRegister';
import { PaginatedResult } from '../_models/pagination';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EmailLog } from '../_models/EmailLog';

@Injectable({
  providedIn: 'root'
})
export class AdminServiceService {

  emailBaseUrl = environment.emailApiUrl;
  photosBaseUrl = environment.photosApiUrl;
  docsBaseUrl = environment.docsApiUrl;
  reviewsBaseUrl = environment.reviewsApiUrl;
  adminBaseUrl = environment.adminApiUrl;
  
  api_EmailUrl = environment.api_emailurl;
  api_PhotosUrl = environment.api_photosurl;
  api_DocsUrl = environment.api_docsurl;

  constructor(private _http: HttpClient) { }

  addSubscription(subscription: SubscriptionForRegister) {
    return this._http.post(this.emailBaseUrl, subscription);
  }

    getSubscriptionsByUserId(id: number) {
      console.log('Getting subscriptions for user id: ', this.emailBaseUrl + id);
      return this._http.get(this.emailBaseUrl + id);
    }

    /* REVIEWS METHODS */
    getReviewsSubscriptionsByUserId(id: number) {
      return this._http.get(this.reviewsBaseUrl + id);
    }

    /* DOCUMENTS METHODS */
    getDocsSubscriptionsByUserId(id: number) {
      return this._http.get(this.docsBaseUrl + id);
    }
  
    getDocsConfiguration(apiKey: any) {
      return this._http.get(this.api_DocsUrl + "documents", this.getHeader(apiKey));
    }
  
    saveDocsConfiguration(projectName: string, apiKey: any, configuration: any) {
      console.log('on service: ', apiKey, configuration);
      if (configuration.id <= 0) {
        console.log('post');
        return this._http.post(this.api_DocsUrl + "documents/" + projectName, configuration, this.getHeader(apiKey));
      } else {
        console.log('put');
        return this._http.put(this.api_DocsUrl + "documents/" + projectName + "/" + configuration.id, configuration, this.getHeader(apiKey));
      }
    }
  
    getDocsFromMediaContainer(projectName: string, folderName: string, apiKey: string) {
      return this._http.get(this.api_DocsUrl + "documents/" + projectName + "/" + folderName, this.getHeader(apiKey));
    }
  
  /* PHOTOS METHODS */
  getPhotosSubscriptionsByUserId(id: number) {
    return this._http.get(this.photosBaseUrl + id);
  }

  getPhotosConfiguration(apiKey: any) {
    return this._http.get(this.api_PhotosUrl + "photos", this.getHeader(apiKey));
  }

  savePhotosConfiguration(projectName: string, apiKey: any, configuration: any) {
    console.log('on service: ', apiKey, configuration);
    if (configuration.id <= 0) {
      console.log('post');
      return this._http.post(this.api_PhotosUrl + "photos/" + projectName, configuration, this.getHeader(apiKey));
    } else {
      console.log('put');
      return this._http.put(this.api_PhotosUrl + "photos/" + projectName + "/" + configuration.id, configuration, this.getHeader(apiKey));
    }
  }

  getPhotosFromMediaContainer(projectName: string, folderName: string, apiKey: string) {
    return this._http.get(this.api_PhotosUrl + "photos/" + projectName + "/" + folderName, this.getHeader(apiKey));
  }

  /* EMAILS */
  getSubscriptionsSummaryByUserId(id: number) {
    return this._http.get(this.emailBaseUrl + id + "/summary");
  }

  getAPIsList() {
    return this._http.get(this.adminBaseUrl + "apis");
  }

  getApiDetails(id: number) {
    return this._http.get(this.adminBaseUrl + "apis/" + id + "/details");
  }

  addNewEmailConfiguration(config: any) {
    return this._http.post(this.api_EmailUrl + "emails/configs", config);
  }

  updateEmailConfiguration(config: any, apiKey: string) {
    return this._http.put(this.api_EmailUrl + "emails/configs", config, this.getHeader(apiKey));
  }

  getEmailConfigurations(apiKey: string) {
    return this._http.get(this.api_EmailUrl + "emails/configs", this.getHeader(apiKey));
  }

  addNewEmailTemplate(apiKey: string, configId: number, data: any) {
    return this._http.post(this.api_EmailUrl + "emails/configs/" + configId + "/templates", data,  this.getHeader(apiKey));
  }

  updateEmailTemplate(apiKey: string, configId: number, data: any) {
    return this._http.put(this.api_EmailUrl + "emails/configs/" + configId + "/templates/" + data.Id, data,  this.getHeader(apiKey));
  }

  getEmailTemplates(apiKey: string, configId: number) {
    return this._http.get(this.api_EmailUrl + "emails/configs/" + configId + "/templates", this.getHeader(apiKey));
  }

  getEmailTemplate(apiKey: string, configId: any, templateId: any) {
    return this._http.get(this.api_EmailUrl + "emails/configs/" + configId + "/templates/" + templateId, this.getHeader(apiKey));
  }

  getEmailTemplateFields(apiKey: string, configId: any, templateId: any) {
    return this._http.get(this.api_EmailUrl + "emails/configs/" + configId + "/templates/" + templateId + "/fields", this.getHeader(apiKey));
  }

  getEmailTemplatePreview(apiKey: string, configId: any, templateId: any, values: any) {
    return this._http.patch(this.api_EmailUrl + "emails/configs/" + configId + "/templates/" + templateId + "/preview", values,this.getHeader(apiKey));
  }

  getSubscriptionLog(apiKey: string, page?, itemsPerPage?): Observable<PaginatedResult<EmailLog[]>> {

    const paginatedResult: PaginatedResult<EmailLog[]> = new PaginatedResult<EmailLog[]>();

    let params = new HttpParams();

    if (page != null && itemsPerPage != null) {
      params = params.append('pageNumber', page);
      params = params.append('pageSize', itemsPerPage);
    }
    params = params.append('apiKey', apiKey);

    console.log(apiKey);
    console.log(params);
    
    //, this.getHeader(apiKey)
    return this._http.get<EmailLog[]>(this.api_EmailUrl + "emails/logs", {observe: 'response', params})
      .pipe(
        map(response => {
          paginatedResult.result = response.body;
          if (response.headers.get('Pagination') != null) {
            console.log('response from server: ', response);
            paginatedResult.pagination = JSON.parse(response.headers.get('Pagination'))
          }
          return paginatedResult;
        })
      );
  }

  getSubscriptionLogChart(apiKey: string) {
    return this._http.get(this.api_EmailUrl + "emails/logs/chart", this.getHeader(apiKey));
  }

  private getHeader(apiKey: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        "x-api-key": apiKey
      })
    };


    return httpOptions;
  }

}

